import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import marked from 'marked';
import get from 'utils/get';
import contentfulImgUtil from 'utils/contentfulImgUtil';
import imageModel from 'models/imageModel';

import withBreakpoint from 'lib/withBreakpoint';
import { Image } from 'components/base';

class LaureateStoryHero extends PureComponent {
  state = {
    windowHeight: window.innerHeight
  };

  getHeroImage = () => {
    const { breakpointData, laureateStory } = this.props;
    const { image, mobileHeroImage } = laureateStory;
    const mobileHeroImageUrl = get(mobileHeroImage, 'url', '');
    const desktopHeroImageUrl = get(image, 'url', '');

    if (
      !!mobileHeroImageUrl &&
      (breakpointData.breakpointIsExtraSmall ||
        breakpointData.breakpointIsSmall)
    ) {
      return contentfulImgUtil(mobileHeroImageUrl, '500');
    }

    return contentfulImgUtil(desktopHeroImageUrl, '2000');
  };

  render() {
    const { breakpointData, laureateStory } = this.props;
    const { windowHeight } = this.state;
    const {
      firstName,
      middleName,
      lastName,
      image,
      awardTimeLine,
      heroImageTint
    } = laureateStory;
    const heightStyle =
      breakpointData.breakpointIsSmall || breakpointData.breakpointIsExtraSmall
        ? { height: `${windowHeight}px` }
        : {};

    return (
      <Fragment>
        <Image
          className="relative LaureateStoryHero w100 overflow-hidden z1 bg-color-dark-gray"
          isBg={true}
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImageRepeat: 'no-repeat',
            ...heightStyle
          }}
          alt={`${firstName} ${middleName} ${lastName} image`}
          src={this.getHeroImage()}
        >
          <div
            className="LaureateStoryHero__tint bg-color-black absolute b0 t0 l0 r0 events-none"
            style={{ opacity: heroImageTint }}
          />
          <div className="LaureateStoryHero__container w100 absolute b0 l0 color-gray flex items-end justify-center">
            <div className="h100 p2 flex flex-col items-center justify-between">
              <div>
                <h2 className="text-center hero-title flex flex-col">
                  {firstName && <span>{firstName}</span>}
                  {middleName && <span>{middleName}</span>}
                  {lastName && <span>{lastName}</span>}
                </h2>
                {awardTimeLine && (
                  <div
                    className="my2 md:my4 text-center hero-description"
                    dangerouslySetInnerHTML={{
                      __html: marked(awardTimeLine)
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </Image>
        <div
          style={{ ...heightStyle }}
          className="absolute w100 vh100 t0 l0 z0 bg-color-dark-gray"
        />
      </Fragment>
    );
  }
}

LaureateStoryHero.propTypes = {
  laureateStory: PropTypes.shape({
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    image: imageModel.propTypes,
    awardTimeLine: PropTypes.string,
    mobileHeroImage: imageModel.propTypes
  })
};

LaureateStoryHero.defaultProps = {
  laureateStory: {
    firstName: '',
    middleName: '',
    lastName: '',
    image: imageModel.default,
    awardTimeLine: '',
    mobileHeroImage: imageModel.default
  }
};

export default withBreakpoint(LaureateStoryHero);
